import type { ReactNode } from 'react'
import { SidebarContext, useSidebarState } from '@/hooks/use-sidebar'

interface SidebarProviderProps {
  children: ReactNode
}

export function SidebarProvider({ children }: SidebarProviderProps) {
  const sidebarState = useSidebarState()

  return <SidebarContext.Provider value={sidebarState}>{children}</SidebarContext.Provider>
}
